import { createSlice } from "@reduxjs/toolkit";

import type { PayloadAction } from "@reduxjs/toolkit";
import type { User } from "@/types/api/types.ts";
import authConfig from "@/config/auth.ts";

export type AuthState = {
  accessToken: string | null;
  user: User | null;
  isAuthenticated: boolean;
};

const initialState: AuthState = {
  accessToken: localStorage.getItem(authConfig.storageTokenKeyName),
  user: null,
  isAuthenticated: !!localStorage.getItem(authConfig.storageTokenKeyName),
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    tokenReceived: (state, action: PayloadAction<{ accessToken: string }>) => {
      state.accessToken = action.payload.accessToken;
      state.isAuthenticated = true;
      localStorage.setItem(
        authConfig.storageTokenKeyName,
        action.payload.accessToken
      );
    },
    userReceived: (state, action: PayloadAction<User>) => {
      state.user = action.payload;
    },
    loggedOut: (state) => {
      state.accessToken = null;
      state.user = null;
      state.isAuthenticated = false;
      localStorage.removeItem(authConfig.storageTokenKeyName);
    },
  },
});

export const { tokenReceived, userReceived, loggedOut } = authSlice.actions;
export default authSlice.reducer;
